import { PropTypes } from 'prop-types'
import Select, { components } from 'react-select'
import icons from 'assets/icons'

const DefaultSelect = ({ selectOptions, handleChange, name, isClearable, isSearchable, isMulti, placeholder, width, borderless, textColor, defaultValue, value, borderColor, backgroundColor, padding, fontSize, menuMinWidth, isFixed, menuPlacement, maxMenuHeight, autoValues, isDisabled }) => {
	const DropdownIndicator = (props) => {
		return (
			<components.DropdownIndicator {...props}>
				<icons.arrowDown color={textColor && textColor} />
			</components.DropdownIndicator>
		)
	}
	const MultiValueLabel = (props) => {
		const isAuto = (autoValues || []).some((id) => Number(id) === Number(props.data.value))
		return (
			<components.MultiValueLabel {...props}>
				<span>{props.data.label}</span>
				{isAuto && (
					<span style={{
						marginLeft: 6,
						fontSize: '0.7rem',
						lineHeight: 1.4,
						background: '#D6DFFF',
						color: '#2251F8',
						borderRadius: '0.25rem',
						padding: '0 0.35rem',
						fontWeight: 600
					}}>otomatik</span>
				)}
			</components.MultiValueLabel>
		)
	}
	const SelectStyle = {
		menu: (provided) => ({
			...provided,
			width: '100%',
			borderRadius: '.5rem',
			overflow: 'hidden',
			zIndex: 2,
		}),

		valueContainer: (provided) => {
			const width = '100%'
			const minWidth = 'fit-content'
			const marginRight = textColor ? '0px' : ".5rem"
			const textAlign = 'center'
			const padding = '0'
			const backgroundColor = 'transparent'
			const cursor = 'pointer'
			return { ...provided, textAlign, minWidth, width, padding, marginRight, backgroundColor, cursor }
		},
		singleValue: (base) => ({
			...base,
			whiteSpace: 'nowrap',
			gridArea: '1/1/2/3',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			textAlign: 'center',
			display: 'flex',
			color: textColor && textColor
		}),
		indicatorsContainer: (provided) => {
			// none of react-select's styles are passed to <Control />
			const backgroundColor = 'transparent'
			return { ...provided, backgroundColor }
		},
		dropdownIndicator: (provided) => {
			// none of react-select's styles are passed to <Control />
			const backgroundColor = 'transparent'
			return { ...provided, backgroundColor }
		},
		indicatorSeparator: (styles) => {
			return {
				...styles,
				display: 'none'
			}
		},
		container: () => ({
			// none of react-select's styles are passed to <Control />
			position: 'relative',
			border: borderless ? 'none' : borderColor ? `1px solid ${borderColor}` : "1px solid #EEEEEE",
			width: width ? width : '100%',
			borderRadius: "0.4rem",
			cursor: 'pointer',
			backgroundColor: backgroundColor ? backgroundColor : '#ffff'
		}),
		placeholder: (provided) => {
			const whiteSpace = 'nowrap'
			const gridArea = '1/1/2/3'
			const overflow = 'hidden'
			const textOverflow = 'ellipsis'
			const textAlign = 'center'
			const display = 'flex'
			const color = '#bbbbbb'
			const backgroundColor = 'transparent'
			const position = 'absolute'
			return { ...provided, whiteSpace, gridArea, overflow, display, textOverflow, textAlign, color, backgroundColor, position }
		},
		control: (styles, { isDisabled }) => {
			// none of react-select's styles are passed to <Control />
			return {
				display: 'flex',
				justifyContent: 'space-between',
				minHeight: padding ? 'unset' : '3rem',
				borderRadius: '.5rem',
				boxShadow: 'none',
				fontSize: fontSize ? fontSize : '1rem',
				fontWeight: borderless ? 'bold' : 'normal',
				padding: borderless ? '.35rem' : padding ? padding : '.35rem 1rem',
				backgroundColor: isDisabled ? 'rgb(242, 242, 242)' : backgroundColor ? backgroundColor : '#fff',
			}
		},
		menuPortal: (styles) => {
			// none of react-select's styles are passed to <Control />
			return {
				...styles,
				minWidth: menuMinWidth ? menuMinWidth : styles.minWidth,
				zIndex: 99999
			}
		},
		option: (styles, state) => {
			return {
				...styles,
				wordBreak: 'break-word',
				cursor: 'pointer',
				fontSize: fontSize ? fontSize : '1rem',
				backgroundColor: state.isSelected ? textColor ? textColor : '#2251F8' : backgroundColor ? backgroundColor : '#fff',
				color: state.isSelected ? '#fff' : 'initial'
			};
		}
	}
	const customFilter = (option, searchText) => {
		if (
			option?.data?.label?.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())
		) {
			return true;
		} else {
			return false;
		}

	}
	return (
		<Select
			defaultValue={defaultValue}
			placeholder={placeholder}
			isMulti={isMulti}
			components={{ DropdownIndicator, ...(autoValues?.length ? { MultiValueLabel } : {}) }}
			isSearchable={isSearchable}
			options={selectOptions}
			menuPlacement={menuPlacement ? menuPlacement : 'auto'}
			maxMenuHeight={maxMenuHeight ? maxMenuHeight : 200}
			styles={SelectStyle}
			name={name}
			isClearable={isClearable}
			value={value && value}
			menuPortalTarget={document.body}
			className={'react-select-container'}
			onChange={handleChange}
			theme={(theme) => ({
				...theme,
				borderRadius: 0,
				colors: {
					...theme.colors,
					primary25: '#E0EBF5',
					primary: '#005D99',
				},
			})}
			filterOption={customFilter}
			menuPosition={isFixed ? 'fixed' : 'absolute'}
			isDisabled={isDisabled}
		/>
	)
}

DefaultSelect.defaultProps = {
	isClearable: false,
	isMulti: false,
	isSearchable: false,
	placeholder: 'Seçiniz',
	borderLess: false
}

DefaultSelect.propTypes = {
	selectOptions: PropTypes.array,
	handleChange: PropTypes.func,
	name: PropTypes.string,
	placeholder: PropTypes.string,
	isClearable: PropTypes.bool,
	isSearchable: PropTypes.bool,
	isMulti: PropTypes.bool,
	width: PropTypes.string,
	borderLess: PropTypes.bool,
	textColor: PropTypes.string,
	defaultValue: PropTypes.object,
}

export default DefaultSelect
